import { gql } from '@apollo/client';

import {
  AddFormMessagesDocument,
  type AddFormMessagesMutation,
  type AddFormMessagesMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddFormMessages($input: AddFormMessagesInput!) {
      addFormMessages(input: $input) {
        messages {
          id
          text
          content
          createdAt
          sender
          transcript
          contentUrl
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
        }
        surveyProgress
      }
    }
  `;
}

export const ADD_FORM_MESSAGES = AddFormMessagesDocument;
export type { AddFormMessagesMutation, AddFormMessagesMutationVariables };
